export const SET_HEADER = 'SET_HEADER';
export const SET_SEARCH_QUERY = 'SET_SEARCH_QUERY';
export const SET_SEATAPI_DATA = 'SET_SEATAPI_DATA';
export const SET_HOME_ACTIVE_MENU = 'SET_HOME_ACTIVE_MENU';
export const SET_TRIPS_ACTIVE_MENU = 'SET_TRIPS_ACTIVE_MENU';
export const RESET_STORE = 'RESET_STORE';
export const SET_DOJ = 'SET_DOJ';
export const POPULATE_BUS_LIST = 'POPULATE_BUS_LIST';
export const FILTER_BUS_LIST = 'FILTER_BUS_LIST';
export const RESET_FILTER = 'RESET_FILTER';
export const TICKET_DETAILS = 'TICKET_DETAILS';
export const PASSENGER_DETAILS = 'PASSENGER_DETAILS';
